import { motion } from 'framer-motion';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../../components/feature/Header';
import Footer from '../../../../components/feature/Footer';

const InouePage = () => {
  // ページ読み込み時のスクロール処理を削除
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const testimonial = {
    name: '井上様',
    title: '代表',
    company: '株式会社フラブ',
    image: 'https://static.readdy.ai/image/d7a11723d8aa082f15ef10141684e0c1/35b8762a66e1873ce7fb0f80abf5f547.png',
    sections: [
      {
        question: '私に相談する前にどんなことで悩んでました?',
        answer: 'まず、頭が散らかってるといいますか、一個一個、これで成功する、成功というか、これやったら仕事決まるなっていうのはなんとなく分かってたんですけども、例えば、例えばっていうか、お会いしたときの状況が、ちょうど展示会前で、大きい展示会前で、ここで成功したいなというイメージはあったんですけども、何をしたらいいかが全く分からずに、お金だけ振り込んで、ほんとに頭が真っ白といいますか、来たお客さんにとにかくもう喋ったらいいかという、漠然すぎるぐらい漠然というのが悩みで、売り上げも、展示会になんで行ったかといいましたら起死回生といいますか、もう伸び悩んで、このまま行ったらどうしようかなという恐ろしい不安からすがりついて、そういうイベントに出ようというところだったんですけど、まぁほんとに悩んでたという時期ですね。暗黒時代みたいな感じです。'
      },
      {
        question: 'では、私には、いつどんなきっかけで興味を持ちました?',
        answer: 'えっとですね。これ正直に言いますと、Ｗさん、Ｙさん、この二人が、僕がちょっと悩んでるというので、まぁちょっとＷさんには印刷物の相談もしてたので、そのときに、とにもかくにも赤石さんと話したら何か見えるよというので、Ｗさんから強くプッシュして頂いたというのがきっかけですね。で、部屋入ったら、入って横に本棚がぶわーっとあって、それ本棚あるけど全部赤石さんの頭ん中入ってんねんって言って、なんかぽんって言ったらぽぽぽぽぽーんって返ってくるから、あんたそんな状態やったらとにかく行ってきっていうのが、まぁ紹介ですね、というのがやっぱ一番大きかったですね。私は、赤石先生はもちろん公認会計士、恐ろしく難しい、友達も、５年６年受けて結局諦めたっていう経緯があったので、そういう資格をお持ちっていうのは知ってたんですけども、自分の頭の中を整理して貰えるっていうのは、全く夢にも思ってなかったので、まぁ紹介はしてもらったんですけど、ちょっと何気なしにすがる思いで来たといいますか。まぁただ、そのときに、ちょうどあのときカフェのいえもんカフェで隣が赤石先生がたまたま座られてたその前にＷさんから言われてたんで、その場で聞けるもんなら聞こうというような感じで聞いたのは記憶にございます。'
      },
      {
        question: 'じゃあ、私をいつどこで知りましたかも、これはもう言わずもがなで。',
        answer: '言わずもがななんですが、まぁ堺でございまして、堺で知ってはいてたんですけども、ただ、全然違うところに行って、大阪のところで、まぁ僕、会社神戸なんですけども、どこでやってんのって、京都です、京都って言ったらなんか、赤石さんがどうのこうのっていう話は何回も聞いたことがあったんで、赤石さん、どこに行ってもなんか出てくるなっていう、なんか印象はありましたね。'
      },
      {
        question: 'じゃあ、もう言うてはるかもしれないんですけど、そのときの第一印象っていうのは。',
        answer: 'えっとね、やっぱり、堅い。堅いっていうのは、堅そうだなというか、赤石さんとお会いしての第一印象ですよね。こっち緊張してしまいますっていうのが第一印象ですね。かなり鋭い指摘をずばっとされるので、されてるのを横目で見てたので、わぁっていう感じでしたね。が第一印象ですね。'
      },
      {
        question: '私に頼むときは、まぁ他のコンサルタントがいると思いますけど、比べたりはしました?',
        answer: '知らず、コンサルの方というかまぁ、僕もこの確固たるコンサル業をやってますという人はお会いしたことはあるんですけども、なかなか相談しきれないといいますか、ちょっと、何をどうやってるんですかみたいな。なんか他の、実実績、他の何か違うことで成功して、自分もそれやっててプラスアルファでその体験をコンサルされてるのか、ほんとにそのコンサルのみでやられてるのかで、ちょっといまいちよく分からなかったもので、相談しきれてなかったという、僕が選んでなかったという部分はありました。他の方、まぁコンサルやられてる方は僕は数人くらいしか分からないんですけども、どちらかというと、僕が悩みを言っても、ちょっと違うといいますか、違う感じで返ってくるといいますか、感覚なんですけども、こうこうこうでこうなんですよと言っても、まぁ言うたらずばっと返ってこないといいますか、で、結局、時間長かったけど何やったんやろうなっていうような感じはしました。というので、他の方、そういうイメージがあったので、なかなかこう、相談しきれなかったっていうのはあったので、まぁそれこそ、印刷やられてるＷさんとかも、ちょっと、ちょっと相談しやすそうな人にそういう話を聞いてたというのはありました。'
      },
      {
        question: '最終的になぜ私に相談したんですか?理由を三つ教えて下さい。',
        answer: 'はい、まずは、もうほんとに困ってたので、ほんとに困ってることを、私が思ってる以上の、１００％以上の２００％３００％の回答が一瞬でバンてきたのが衝撃でしたね。もうそれが強烈な一つですね。もう一つは、これ私の癖でもありますし多くの人が持ってる悩みだと思うんですけど、頭で分かっても、実行しにくいっていうのが、まぁおそらく誰の話でもふんふんって聞いてああそうやな今日はええ話聞いたわとかって終わってしまうのを、赤石先生は、今やるのかいつまでにやるのか、今やらへんかったらどうなるのかっていうのをかなり明確にしかも力強く言って頂けたんで、もうほんと行動が出来たというのは、まぁその行動を、行動を起こさないと結果変わらないですよということを強く言われて、しかも時間取ってもらって行動を起こす時間、１本目の時間までもらって、それをPEndPointいたこと、言い換えればやらされたこと、というのが二つ目に、理由としては二つ目ですね。三つ目は、方法を教えて頂いて、まぁよくありがち、よくありがちと言いますか、私のいいところをポンっと、能力を引き上げようとしてくれるところというのが三つ目なんですけども。これもまた僕もそこで、自分で選んでしまう基準っていうのが、私の仕事の分野をぐちゃぐちゃっとされるのではなくて、僕の大事な部分は置いといて、積み木を綺麗に、積んで行って頂けるような作業をして頂いたので、僕がいつもちょっと嫌だなと思ってしまうのが、積み木でこの四角の積み木があるのにこれ１回ぺちゃんこにされて丸にして、いやこれ丸やねんって、この上三角乗せやすいねんって、この形を崩されるっていうのが、一番困惑するといいますか、なんかせっかく積み上げてきたものが、無しかいっていうふうになってしまうのが。ほんとに綺麗に、こうやってこうやって上手く乗りますよっていう作業をして頂いたので、三つ目はほんとに上手く引き上げて頂いたというのが三つ目ですね。この三つになります。'
      },
      {
        question: '相談してどのように活用されてますか?',
        answer: '今ですね、まず、活用、具体的でもいいんですよね。例えばパンフレットを作り直したといいますか、新たに作りました。これは、赤石先生から紹介して頂いた方からのあれで作り直してもらったんですけども、これをそのアイデアを元に作ったパンフレットで、まぁその前までは、まぁちょっとパンフレットっていうのが、パンフレット下さいって言われるようなことがほぼ無い状態ですね。ひきあいといいますか、入ってパンフレット渡しても、私自身も、このパンフレットといいますか、他のパンフレットを見ながら説明したことがなかったというのが一つなんですけども。お客さんからパンフレット請求がまぁなかったというのが、これは、一般客向けではなくて、私のターゲットの理容室さん向けのパンフレットなんですが、これが、今まで全くなかったひきあいパンフレット請求が、ここ３ヶ月で、１回刷り終わってもう１回終わるまで３５００部のパンフレット請求があるので、ですので言ったら３５００件ですよね。３５００のターゲットのところに届くようになったというのが、一つの成果になります。そこからもちろん、これを見て、ちょっと説明聞きに来たいというようなことで、説明を聞きに来られてというような方もいらっしゃいまして、まぁ楽に集客、ちょっとこれ数字になるんですけども。お願い営業を辞めましたということなんですが。お願い営業を辞めて、人を集めて、講習会をするというようなことで、まぁ今これ平均なんですけど１６回、開催しまして、平均来られるオーナーさんの数が１０人。２万円の商品が売れる数が６０個、契約率７９％。約１００万ちょっとというのが売り上げといいますか、流通価格になります。というのが、まぁ元々これは、ほぼこういうことをしてなかったので、だいたいまぁ１時間に、お願い営業をしますと、１時間に１個売れるのが良くて、１日頑張って８個売れたらわぁようやったなという、そのあとポロポロポロポロって注文来るんですけども、まぁそれと比較すると、１時間半のこういう説明会でボンっと数字が上がりますので、恐ろしく成果が上がりましたと、いうところですね。'
      },
      {
        question: '具体的には私に相談して、金銭的価値ってどのくらいありましたか?',
        answer: '金銭的価値は、まぁ僕の数字で言いますと、難しいな金銭的価値。可能性でもいいですか？僕、１時間に、６０倍やから、１時間ちょっと単位で表したら、え、どうなんねや、何で表したらいいですかね。じゃあ時給にしますと、流通価格ですからあれですけど、流通で時給２万やったところが、時給６０万ぐらいですかね、に上がったので、１時間６０万円の価値、１日８時間、その計算おかしいか。あ、１日、１日８個売れてたのが６０やから、８×２＝１６万。１６万と、６０×２＝１２０万、ということは。７．５倍、１日、違うな。仕事の生産率が７．５倍に上がりました。ということは、仕事の生産率が７．５倍に上がったということは、え、どういう数字出すんだろ。７．５倍掛けたらいいのかな。７．５倍。あ、そうか、もしもこれが普通の営業やったらって考えたら、１６×１日８個やから８。１２８個。１２８個×２で２５６万。１６回で２５６万。これが１６回で１６３３万。１６３３万ということは、これ３ヶ月やから。平均５．３回。５．３回×１２＝年間６３．６。１ヶ月５．３。年間６３．６だから。あ、これ割ったらええか。ということは１ヶ月で、なんでこんなことになるんや、１ヶ月だからこれを５．３で割らなあかんねん。×１２。３６５２万７５４７円。１２３９万４９２０円。こんなんなるの？あ、そうか、そういうことやな。３６５２７５４７−１０２３９９９９＝年間２６２８万７５４８円の価値がありました。'
      },
      {
        question: '私のこの相談の良いところと悪いところを三つ教えてください。',
        answer: '良いところは、ずばっと心臓を掴まれて言われると、いうところが良いところです。良いとこの一つです。もう一つは、これ良いところと悪いところと順番で言っていいですか？良いところは心臓をずばっとして言うところが良いところなんですが、悪いところは、もしこっちがそんな真剣じゃなくて相談してたら、ずばっといきすぎて嫌になって返ってたかもしれないですね。というのが悪いというよりかは、自分がほんまに相談する気があったら大丈夫ですっていうこっちの状態ですね。要するに赤石先生が悪いっていうようなことは無いです。二つ目は、その場で実行させて頂くっていうことが、まぁ、やりなさいって言うことがあったのでその点は良かったなと思います。やらないといけないと。もう一つの点を言うと、そこまで自分が思ってなかったら心が折れてその場で、ちょっと今日出来ませんなんか言いながら、次絶対相談せえへんわって、もうあそこ行ったらめっちゃなんかやらされるもんって思ってしまいそうなところがもう１点です。三つ目は、自分がやってきたことに対して組み立てて頂けるので、仮にですけど、自分に実績がなくて相談してたら、ひょっとしたら難しかったのかなとも思います。ですので、実績というか今までやってきた何かがあって、それに対して相談するというのは、非常に、僕から見たらすごいいいです。ただ、今から、何かやりたいんですけどっていうような、あ、でもそれでもいけるか、なんかって積み重ねていけるから行けるか。じゃあ悪いとこないですね。まぁあとは、悪いっちゅうかこっちの問題かなと思いますね。真剣に言ってもらってるのを受け止めて信頼して投げれるかというところやと思いますし。いい加減な気持ちで聞きに来ないようがいいよという、のときに相談して良かったなと思いますね。やっぱいい加減な、なんかフラフラとしながら聞きに来てたら、ちょっと思いつめてたかもしれないですね。'
      },
      {
        question: '当社への今後の期待、要望を教えて下さい。',
        answer: 'ちょっとやっぱ悩んでるとか困ってるという人がやはり多いので、まぁ極力こう、フランクな形で相談に乗って頂ける環境があれば、やりやすいかなと思います。ですので例えばですけど僕なんかは誰かに、Ｗさんとかに、あんたそれが夢やったら赤石さんに相談したらええやないのと言われなければ、僕自身はそういう、会社のお金に関する、まぁ公認会計士さんが仕事とされてる、本業ど真ん中からそれてますので、まさかという感じといいますか、まさかの部分だったので、ですので、ちょっとそのまさかのギャップはものすごいいいんですけど、その違うところのギャップで何かこうして頂ければ、積極的に参加したいなとか、そういう部分でもっと多くの、多くのっていうのもあれですけど、志ある人と会って頂きたいなということは思います。'
      }
    ]
  };

  const otherTestimonials = [
    {
      name: '仲井 美和',
      company: '関西ビジネスサテライト',
      title: '代表取締役',
      image: 'https://static.readdy.ai/image/d7a11723d8aa082f15ef10141684e0c1/127d7ef9c2e9720f90b5b1713d70cfca.png',
      link: '/testimonials/interview/nakai-miwa'
    },
    {
      name: '岡田 学',
      company: '株式会社イビリス',
      title: '代表取締役',
      image: 'https://static.readdy.ai/image/d7a11723d8aa082f15ef10141684e0c1/2f9f9198753682b69ba4c9262eb11081.png',
      link: '/testimonials/interview/okada-manabu'
    },
    {
      name: '尾西様',
      company: 'コンサルティング事業',
      title: '代表',
      image: 'https://static.readdy.ai/image/d7a11723d8aa082f15ef10141684e0c1/01b737107832c8916c5b9b65ecaa5c33.png',
      link: '/testimonials/interview/onishi'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <section className="pt-32 pb-20 bg-gradient-to-b from-gray-50 to-white">
          <div className="max-w-7xl mx-auto px-6">
            {/* 戻るボタン */}
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              className="mb-8"
            >
              <a
                href="/testimonials"
                className="inline-flex items-center gap-2 text-gray-600 hover:text-red transition-colors cursor-pointer"
              >
                <i className="ri-arrow-left-line text-xl"></i>
                <span className="text-sm font-medium">お客様の声一覧に戻る</span>
              </a>
            </motion.div>

            {/* ヘッダー */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              className="text-center mb-16"
            >
              <h1 className="text-5xl font-bold text-gray-900 mb-6">
                お客様インタビュー
              </h1>
              <p className="text-xl text-gray-600">
                {testimonial.company} {testimonial.name}
              </p>
            </motion.div>

            {/* コンテンツ */}
            <div className="grid lg:grid-cols-5 gap-12">
              {/* 左側:プロフィール */}
              <motion.div
                initial={{ opacity: 0, x: -30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.2 }}
                className="lg:col-span-2"
              >
                <div className="sticky top-8">
                  <div className="relative rounded-3xl overflow-hidden shadow-2xl mb-8">
                    <div className="w-full">
                      <img
                        src={testimonial.image}
                        alt={testimonial.name}
                        className="w-full h-auto object-contain"
                      />
                    </div>
                  </div>

                  <div className="bg-gradient-to-br from-red/5 to-red-light/5 rounded-3xl p-8 border border-red/10">
                    <h3 className="text-3xl font-bold text-red mb-4">
                      {testimonial.company}
                    </h3>
                    <p className="text-gray-600 mb-2">{testimonial.title}</p>
                    <p className="text-xl font-medium text-gray-900">
                      {testimonial.name}
                    </p>
                  </div>
                </div>
              </motion.div>

              {/* 右側:インタビュー内容 */}
              <motion.div
                initial={{ opacity: 0, x: 30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.3 }}
                className="lg:col-span-3"
              >
                <div className="space-y-10">
                  {testimonial.sections.map((section, index) => (
                    <motion.div
                      key={index}
                      id={index === 0 ? "interview-content" : undefined}
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ delay: 0.4 + index * 0.1 }}
                      className="bg-white rounded-2xl p-8 border border-gray-100 hover:border-red/20 hover:shadow-lg transition-all"
                    >
                      <div className="flex items-start gap-4 mb-6">
                        <div className="w-10 h-10 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0">
                          <span className="text-red font-bold text-sm">Q{index + 1}</span>
                        </div>
                        <h4 className="text-xl font-bold text-gray-900 leading-relaxed pt-1">
                          {section.question}
                        </h4>
                      </div>

                      <div className="flex items-start gap-4">
                        <div className="w-10 h-10 bg-red-light/10 rounded-full flex items-center justify-center flex-shrink-0">
                          <span className="text-red-light font-bold text-sm">A</span>
                        </div>
                        <div className="text-gray-700 leading-relaxed pt-1">
                          {section.answer.split('。').map((sentence, i) => (
                            sentence.trim() && (
                              <p key={i} className="mb-3">
                                {sentence.trim()}。
                              </p>
                            )
                          ))}
                        </div>
                      </div>
                    </motion.div>
                  ))}
                </div>

                {/* CTA */}
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.8 }}
                  className="mt-16 bg-gradient-to-br from-red-dark to-red rounded-3xl p-12 text-center"
                >
                  <h3 className="text-3xl font-bold text-white mb-4">
                    あなたも「勝つ経営」を実現しませんか?
                  </h3>
                  <p className="text-white/90 mb-8 text-lg">
                    無料相談で、あなたのビジネスの可能性を一緒に探りましょう
                  </p>
                  <a
                    href="/#contact"
                    className="inline-block bg-white text-red px-12 py-4 rounded-full text-[15px] font-medium hover:bg-gray-50 transition-all hover:scale-105 whitespace-nowrap cursor-pointer shadow-xl"
                  >
                    無料相談を予約する
                  </a>
                </motion.div>

                {/* Other Testimonials Section */}
                <section className="py-20 bg-gradient-to-br from-red/5 via-white to-red-light/5">
                  <div className="max-w-7xl mx-auto px-6">
                    <motion.h2
                      initial={{ opacity: 0, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12"
                    >
                      他のお客様の声
                    </motion.h2>
                    <div className="grid md:grid-cols-3 gap-8">
                      {otherTestimonials.map((testimonial, index) => (
                        <motion.a
                          key={testimonial.id}
                          href={testimonial.link}
                          initial={{ opacity: 0, y: 30 }}
                          whileInView={{ opacity: 1, y: 0 }}
                          viewport={{ once: true }}
                          transition={{ delay: index * 0.1 }}
                          className="group relative rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all cursor-pointer"
                        >
                          <div className="relative" style={{ aspectRatio: '1920/1080' }}>
                            <img
                              src={testimonial.image}
                              alt={testimonial.name}
                              className="w-full h-full object-cover"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end justify-center pb-12">
                              <div className="text-center">
                                <div className="inline-flex items-center gap-2 bg-white text-red px-8 py-3 rounded-full font-medium">
                                  <span>詳しく見る</span>
                                  <i className="ri-arrow-right-line"></i>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="p-6 bg-gradient-to-br from-red/5 to-red-light/5 border-t border-red/10">
                            <h3 className="text-xl font-bold text-red mb-2">
                              {testimonial.company}
                            </h3>
                            <p className="text-gray-600 text-sm mb-1">{testimonial.title}</p>
                            <p className="text-lg font-medium text-gray-900">
                              {testimonial.name}
                            </p>
                          </div>
                        </motion.a>
                      ))}
                    </div>
                  </div>
                </section>
              </motion.div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default InouePage;
